import { useRecoilValue } from 'recoil';
import { userOrganizationAtom } from 'services/userOrganization/atom';
import { userAtom } from 'services/user/atoms';
import { OrganizationGroupRole, UserRole } from 'generated-graphql/types';
import { useMemo } from 'react';

export const useIsAdmin = () => {
  const userOrganization = useRecoilValue(userOrganizationAtom);
  const user = useRecoilValue(userAtom);

  const isAdmin = useMemo(() => {
    return (
      userOrganization?.role === UserRole.Admin ||
      user?.organizationGroupRole ===
        OrganizationGroupRole.OrganizationGroupAdmin
    );
  }, [userOrganization, user]);

  return { isAdmin };
};
